import { GetterTree } from 'vuex'
import { Mail, MailsState } from '@/store/mails/types'
import { RootState } from '@/store/types'
import _ from 'lodash'

const getters : GetterTree<MailsState, RootState> = {
  /**
   * メールをIDをもとに取得
   * @param {string} notificationId メールID
   * @returns {Mail|undefined}
   */
  findMailById: (state) => (notificationId: string): Mail|undefined => {
    return _.find(state.mails, { id: notificationId })
  },
}

export default getters
